import FormattedMessage from 'I18n/components/FormattedMessage';
import { Caption, LayoutSpaceVertical, Link } from 'breeze-intelligence-kit';
import { useEnrichmentCredits } from './EnrichmentCreditsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DisclaimerMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "enrichmentCredits.disclaimer"
});
export const DisclaimerMessageOverage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "enrichmentCredits.disclaimerOverage"
});
export const DisclaimerMessageOveragePanel = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "enrichmentCredits.disclaimerOveragePanel"
});
export const DisclaimerText = () => {
  const {
    showOverage
  } = useEnrichmentCredits();
  const href = 'https://knowledge.hubspot.com/account/understand-breeze-intelligence-credits-and-billing';
  return /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
    gap: "space-xxs",
    children: [/*#__PURE__*/_jsx(Caption, {
      as: "div",
      children: showOverage ? /*#__PURE__*/_jsx(DisclaimerMessageOverage, {}) : /*#__PURE__*/_jsx(DisclaimerMessage, {})
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: href,
      target: "_blank",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.modals.enrichRecords.learnMore"
      })
    })]
  });
};